function MoneyHeroMarkIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M19.5451 9.67661L18.3371 17.5106C18.2202 18.2851 18.8242 19 19.5938 19H20.5582L22 9.67661H19.5451Z"
        fill="#212121"
      />
      <path
        d="M19.019 13.1419H15.8627L16.1646 11.166C16.2816 10.3915 15.6776 9.67661 14.908 9.67661H13.9435L13.4077 13.1419H11.284C10.6897 13.1419 10.1832 13.5787 10.0955 14.1745L9.89091 15.5248H13.0473L12.7453 17.5007C12.6284 18.2752 13.2324 18.9901 14.002 18.9901H14.9664L15.5022 15.5248H17.6259C18.2202 15.5248 18.7268 15.0879 18.8144 14.4922L19.019 13.1419Z"
        fill="#212121"
      />
      <path
        d="M16.1646 10.7589C16.0672 10.1532 15.5412 9.67661 14.908 9.67661H13.9435L13.7779 10.7589L13.4077 13.1419L14.83 13.1419C15.4048 13.1419 15.8919 12.7447 16.0088 12.1787L16.1646 11.166C16.1841 11.027 16.1841 10.888 16.1646 10.7589Z"
        fill="#212121"
      />
      <path
        d="M14.0701 15.5348C13.4954 15.5348 13.018 15.9319 12.8914 16.4879L12.7355 17.5106C12.716 17.6496 12.716 17.7886 12.7355 17.9177C12.8329 18.5234 13.359 19 13.9922 19H14.9566L15.1222 17.9177L15.4924 15.5348H14.0701Z"
        fill="#212121"
      />
      <path
        d="M10.2026 12.6057C10.5144 12.4071 10.8943 12.2879 11.2937 12.2879H12.6965L13.8363 5H12.112C11.586 5 11.0989 5.24823 10.7871 5.66525L7.73794 9.78581L6.34486 6.14184C6.08183 5.45674 5.42913 5 4.70823 5H3.45153L2 14.3333H4.39649L4.53288 13.4099L4.96152 10.4511V10.4709L5.02971 10.044L6.61763 14.3333H7.86458L10.6118 10.0539L10.1929 12.6156L10.2026 12.6057Z"
        fill="#212121"
      />
    </svg>
  );
}

export default MoneyHeroMarkIcon;
